"use client";
import * as React from "react";
const SvgLoginRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M6.64 3.66a.75.75 0 0 0 0 1.08l1.52 1.48H.8c-.44 0-.8.35-.8.78s.36.78.8.78h7.36L6.64 9.26a.75.75 0 0 0 0 1.08.8.8 0 0 0 1.12 0l2.87-2.79a.76.76 0 0 0 0-1.1l-2.87-2.8a.8.8 0 0 0-1.12 0m7.76 8.8H8.8c-.44 0-.8.34-.8.77s.36.78.8.78h5.6c.88 0 1.6-.7 1.6-1.56V1.56C16 .7 15.28 0 14.4 0H8.8c-.44 0-.8.35-.8.78s.36.78.8.78h5.6z" }));
export {
  SvgLoginRound as default
};
